<template>
  <div></div>
</template>

<script>
export default {
  name: 'LklBack',
  created() {
    const { query, meta } = this.$route
    document.title = meta.title
    document.addEventListener('UniAppJSBridgeReady', function () {
      const type = query.type || 'switchTab'
      const url = query.url || '/pages/tabbar/program/program'
      console.log(type, url)
      window.uni[type]({
        url
      })
    })
  }
}
</script>

<style></style>
